export default __webpack_public_path__ + "static/media/banner_principal.f824b89a.jpg";